import createReducer, { createCollectionStatusReducer } from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';
import { Questions } from '../constants/Feedback';
import { combineReducers } from 'redux';
import cloneDeep from 'lodash/cloneDeep';

const status = createCollectionStatusReducer(
  ActionTypes.FETCH_FEEDBACK_ERROR,
  ActionTypes.FETCH_FEEDBACK_REQUEST,
  ActionTypes.FETCH_FEEDBACK_SUCCESS
);

export const mergeFeedback = (state, { payload }) => {
  const { id } = payload;
  const existing = state[id] ? state[id].feedback : [];
  const toMerge = payload.feedback || [];
  return {
    ...state,
    [id]: {
      id,
      feedback: mergeArrayById(existing, toMerge)
    }
  };
};

export const updateFeedbackAnswer = (state, { payload }) => {
  const { jobId: id } = payload;
  const existing = state[id] ? state[id].feedback : [];

  const clone = cloneDeep(existing);

  const findQuestion = question => question.id === payload.questionId;

  const feedbackCategory = clone.find(feedbackCategory =>
    feedbackCategory.questions.find(findQuestion)
  );
  const selectedQuestion = feedbackCategory.questions.find(findQuestion);

  if (selectedQuestion.id === Questions.HOW_LIKELY_RECOMMEND_HIPAGES) {
    selectedQuestion.selected = payload.answerId;
    selectedQuestion.comments = payload.comments;
  } else {
    let assignmentAnswer = selectedQuestion.jobAssignments.find(
      assignment => assignment.id === payload.jobAssignmentId
    );

    if (!assignmentAnswer) {
      assignmentAnswer = {
        selected: payload.answerId,
        comments: payload.comments || '',
        id: payload.jobAssignmentId
      };

      selectedQuestion.jobAssignments.push(assignmentAnswer);
    } else {
      assignmentAnswer.selected = payload.answerId;
      assignmentAnswer.comments = payload.comments || '';
    }

    assignmentAnswer.shouldPersistLocally = payload.shouldPersistLocally;
  }

  return {
    ...state,
    [id]: {
      id,
      feedback: clone
    }
  };
};

export const removeFeedbackAnswer = (state, { payload }) => {
  const { jobId: id } = payload;
  const existing = state[id] ? state[id].feedback : [];

  const clone = cloneDeep(existing);

  const feedbackCategory = clone.find(
    feedbackCategory => feedbackCategory.id === payload.feedbackCategoryId
  );
  const selectedQuestion = feedbackCategory.questions.find(
    question => question.id === payload.questionId
  );

  selectedQuestion.jobAssignments = selectedQuestion.jobAssignments.filter(
    assignment => assignment.id !== payload.jobAssignmentId
  );

  return {
    ...state,
    [id]: {
      id,
      feedback: clone
    }
  };
};

const mergeArrayById = (existing, toMerge) => {
  const oldKeyValue = existing.map(obj => [obj.id, obj]);
  const map = new Map(oldKeyValue);
  toMerge.forEach(obj => {
    const toAdd = map.has(obj.id) ? { ...map.get(obj.id), ...obj } : { ...obj };
    map.set(obj.id, toAdd);
  });
  return [...map.values()];
};

const list = createReducer(
  {},
  {
    [ActionTypes.FETCH_FEEDBACK_SUCCESS]: mergeFeedback,
    [ActionTypes.UPDATE_FEEDBACK_ANSWER]: updateFeedbackAnswer,
    [ActionTypes.REMOVE_FEEDBACK_ANSWER]: removeFeedbackAnswer
  }
);

export default combineReducers({ status, list });
